<nb-card style="margin:10px;">
  <nb-card-header>
    <div class="title">
      <span i18n="@@UpgradePlan">Upgrade Plan</span>
    </div>
  </nb-card-header>

  <nb-card-body>

    <span>
      {{Message}}
    </span>

  </nb-card-body>

  <nb-card-footer>
    <div class="actions float-right">
      <button i18n="@@Upgrade" nbButton type="submit" class="btn-circle btn-xl btn-main" status="success" (click)="Upgrade()">Upgrade</button>
      <button i18n="@@Back" nbButton type="button" class="btn-circle btn-xl btn-back"  class="back" (click)="Back()">Cancel</button>
    </div>
  </nb-card-footer>

</nb-card>
